import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import type { ImageRefDto } from '../../shared/models/marketing.models';

export type MarketingCountryCardModel = {
  slug: string;
  name: string;
  shortDescription?: string;
  image?: ImageRefDto;
};

@Component({
  selector: 'app-marketing-country-card',
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host {
      display: block;
      min-width: 0;
    }
  `,
  template: `
    <a class="h1-dest-card" [routerLink]="['/countries', country.slug]">
      <div class="h1-dest-card__media" [style.background-image]="cardBackgroundImage()" aria-hidden="true"></div>
      <div class="h1-dest-card__overlay" aria-hidden="true"></div>
      <div class="h1-dest-card__body">
        <div class="h1-dest-card__name">{{ country.name }}</div>
        @if (countryMeta(); as meta) {
          <div class="h1-dest-card__meta">{{ meta }}</div>
        }
      </div>
    </a>
  `,
})
export class MarketingCountryCardComponent {
  @Input({ required: true }) country!: MarketingCountryCardModel;

  cardBackgroundImage(): string {
    const url = this.country.image?.cdnUrl;
    if (!url) {
      return 'linear-gradient(140deg, #1d3b5c 0%, #3c6890 100%)';
    }
    return `linear-gradient(180deg, rgba(10, 23, 51, 0.12) 0%, rgba(10, 23, 51, 0.35) 100%), url(${url})`;
  }

  /** Short single-line meta like home1 (“120+ universities”), not the full country lede. */
  countryMeta(): string | null {
    const raw = this.country.shortDescription?.trim();
    if (!raw) return 'Explore programs';
    const firstSentence = raw.split(/(?<=[.!?])\s+/)[0]?.trim() ?? raw;
    if (firstSentence.length <= 56) return firstSentence;
    return `${firstSentence.slice(0, 53).trimEnd()}…`;
  }
}
